import { Theme, Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BatteryLevelsEnum } from '@/types/asset_search';
import { container, title } from './vehicleBatteryBadge.style';

import { getColorConfig } from './utils';

interface IProps {
  batteryLevel?: BatteryLevelsEnum;
}

export const VehicleBatteryBadge = ({ batteryLevel }: IProps) => {
  const { t } = useTranslation();
  const theme = useTheme<Theme>();
  const isLow =
    batteryLevel === BatteryLevelsEnum.LOW ||
    batteryLevel === BatteryLevelsEnum.EXTREMELY_LOW;

  const { borderColor, backgroundColor, color, icon } = getColorConfig(
    theme,
    isLow,
  );

  return (
    <Box
      sx={() => container(borderColor, backgroundColor, color)}
      data-testid="map-overlay-vehicle-level"
    >
      {icon}
      <Typography style={title}>
        {t(`vehicleBattery.${batteryLevel || 'No Voltage Available'}`)}
      </Typography>
    </Box>
  );
};
